import { DateTime } from "luxon"

const API_KEY = '5ebbed7852a66b4cd043788fabc4bf89'
const BASE_URL = 'https://api.openweathermap.org/data/2.5/'

const getWeather = (infoType, searchParams) => {
    const url = new URL(BASE_URL + "/" + infoType)
    url.search = new URLSearchParams({...searchParams, appid:API_KEY})

    return fetch(url).then( (res) => res.json()) 
}

const formatCurrentWeather = (data) => {
    const { 
        coord: {lat, lon}, 
        main:{temp, feels_like, temp_min, temp_max, humidity}, 
        name, 
        dt, 
        sys: {country, sunrise, sunset}, 
        weather, 
        wind: {speed}
    } = data

    const {main: details, icon} = weather[0]

    return {lat, lon, temp, feels_like, temp_min, temp_max, humidity,
            name, dt, country, sunrise, sunset, details, icon, speed}
}

// const formatForecastweather = (data) => {
//     let {
//         timezone, daily , hourly
//     } = data
//     daily = daily.slice(1, 6).map( d => {
//         return {
//             title: formatToLocalTime(d.dt, timezone, 'ccc'),
//             temp: d.temp.day,
//             icon: d.weather[0].icon
//         }
//     })

//     hourly = hourly.slice(1,6).map( d => {
//         return {
//             title: formatToLocalTime(d.dt, timezone, 'hh:mm a'),
//             temp: d.temp.day,
//             icon: d.weather[0].icon
//         }
//     })

//     return { timezone, daily, hourly }
// }

const getFormattedweatherData = async (searchParams) => {
    const formatted = await getWeather('weather', searchParams).then(formatCurrentWeather)

    // const {lat, lon} = formatted
    // console.log('formatted', formatted)
    // const formattedForecastWeather = await getWeather('onecall', {
    //     lat, 
    //     lon, 
    //     exclude:"current,minutely,alerts", 
    //     units: 'metric',
    // }).then(formatForecastweather)

    
    return formatted
}

const formatToLocalTime = (
    secs, 
    zone, 
    format = "cccc, dd LLL yyyy' | Local time: 'hh:mm a"
) => DateTime.fromSeconds(secs).setZone(zone).toFormat(format)

// const iconUrlFromCode = (code) => {
//    return `http://openweathermap.org/img/wn/${code}@2x.png`
// }
export default getFormattedweatherData;

export { formatToLocalTime }